<template>
  <router-link
    :to="{ name: 'appointment.show', params: { id: appointment.id } }"
    tag="div"
    class="group shadow mb-6 cursor-pointer text-grey-darkest leading-normal"
  >
    <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
      <avatar
        :avatar="appointment.doctorAvatar"
        :name="appointment.doctorFirstName + ' ' + appointment.doctorLastName"
        class="mr-2 w-10 h-10 md:w-12 md:h-12"
      ></avatar>
      <div class="ml-4">
        <div class="flex md:mb-1">
          <span class="icon mr-2 md:text-lg text-grey-darkest">
            <i class="mdi mdi-calendar-check"></i>
          </span>
          <span
            class="text-grey-darkest font-semibold text-sm md:text-base"
          >{{ appointment.date | momentFormat('YYYY-MM-DD', $t('date_selector_format')) }} {{ $t('at') }} {{ appointment.time | momentFormatTime($t('time_format')) }}</span>
        </div>
        <div class="flex md:mb-1">
          <span class="icon mr-2 text-lg text-red-light">
            <i class="mdi mdi-map-marker"></i>
          </span>
          <span class="text-sm md:text-base">
            {{ appointment.officeZipCode }} {{ appointment.officeLocality }}
            <br />
            {{ appointment.officeStreetNumber }} {{ appointment.officeStreetName }}
          </span>
        </div>
        <div class="flex md:mb-1">
          <span class="icon mr-2 text-lg text-blue-light">
            <i class="mdi mdi-account"></i>
          </span>
          <span
            class="text-sm md:text-base"
          >{{ appointment.doctorFirstName + ' ' + appointment.doctorLastName }}</span>
        </div>
        <div class="flex md:mb-1">
          <span class="icon mr-2 text-sm text-grey">
            <i class="mdi mdi-briefcase"></i>
          </span>
          <span class="text-sm">
            {{ $t('type_' + appointment.emergencyType) }}
            <span
              class="mdi mdi-check-circle text-green"
              v-if="appointment.isDoctorMemberOfOsteopathie"
            ></span>
          </span>
        </div>
        <div class="flex">
          <template
            v-if="appointment.isDoctorRegulated && (appointment.emergencyType !== 'OSTEOPATH' && appointment.emergencyType !== 'PSYCHOLOGIST')"
          >
            <span class="icon mr-2 text-sm text-green">
              <i class="mdi mdi-currency-eur"></i>
            </span>
            <span class="text-sm text-green">{{ $t('Contracted_doctor') }}</span>
          </template>
          <template
            v-if="!appointment.isDoctorRegulated && (appointment.emergencyType !== 'OSTEOPATH' && appointment.emergencyType !== 'PSYCHOLOGIST')"
          >
            <span class="icon mr-2 text-sm text-red">
              <i class="mdi mdi-currency-eur"></i>
            </span>
            <span class="text-sm text-red">{{ $t('Contracted_doctor_negative') }}</span>
          </template>
        </div>
        <!-- OFFICE SETTINGS -->
        <OfficeSettings
            v-if="appointment.officeSettings"
            :accessible="appointment.officeSettings.accessible"
            :card="appointment.officeSettings.card"
            :cash="appointment.officeSettings.cash"
        />
        <!-- OFFICE SETTINGS -->
      </div>
    </div>
    <div
      class="transition flex rounded-b bg-teal group-hover:bg-teal-dark text-white py-1 justify-center"
    >
      <span
        class="uppercase tracking-wide font-semibold text-sm"
        v-text="$t('Appointment_confirmed')"
      ></span>
    </div>
  </router-link>
</template>
<script>
import OfficeSettings from '@/components/Patient/OfficeSettings'

export default {
  name: "appointment-list-item",

  components: {OfficeSettings},

  props: ["appointment"]
};
</script>



// WEBPACK FOOTER //
// src/components/Patient/AppointmentListItem.vue